import { createComponentState } from '@/state';

// Modal states stored as a map of modalName -> modalPayload
const useModals = createComponentState<Record<string, unknown>>({});

export default useModals;
